export default __webpack_public_path__ + "static/media/upload-cloud 1.a7a5a667.svg";